export default __webpack_public_path__ + "assets/images/completed-legend.png";